import { SET_ZOO_TYPE } from '../actions/zoo.actions';
import { setWelfareVariant } from '../../i18n';

/*
    Keep the i18n welfare overlay in sync with zooType: when the zoo is a
    laboratory, every t() call resolves to the "_lab" variant of its key
    (falling back to the base key if no variant exists).
*/
const welfareVariant = store => next => action => {
    const result = next(action);
    if (action.type === SET_ZOO_TYPE) {
        setWelfareVariant(action.value === 'lab' ? 'lab' : null);
    }
    return result;
};

export default welfareVariant;
